import Scene = Phaser.Scene;
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import {BigStandardPanel} from "@/scenes.ui/big-standard-panel";
import {PortalDto} from "@/store/portal/types";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import CU from "@/utils/c-u";
import {BuyButton} from "@/scenes.ui/buy-button";
import BaseSound = Phaser.Sound.BaseSound;
import TextUtils from "@/utils/text-utils";
import {SpaceTr, SpaceTrSpace, Tr, TrSpace} from "@/i18n/i18n";
import PlaceStore from "@/store/place";
import PlayerStore from "@/store/player";
import PortalStore from "@/store/portal";

export class PortalPanel extends BigStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene, canvas, Tr('pt'));
    }

    public init(p: PortalDto, clickSound: BaseSound, onAcceptCallback: (discount?:number) => unknown, discounts?:number[],  currentDiscount?: number) {

        let back = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PORTALS, Keys.PORTAL_PANEL_BACK);
        let portal = SpriteUtils.addSprite(this.scene, 0, -160, p.atlasKey, p.imageKey);


        let buttonLight = SpriteUtils.addSprite(this.scene, 0, 230, Keys.ATLAS_PORTALS, Keys.PORTAL_PANEL_LIGHT);

        let textBlock = new BBCodeText(this.scene, - 450 * CU.S / 2, -85 * CU.S, p.desc, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 450
            }
        }).setScale(CU.S, CU.S);

        let lengthText = TextUtils.addText(this.scene, Tr('rl') + String(p.length / 10000) + SpaceTr('km'), 2, 122, '#ececec',
            11, 'normal', 200);

        // let placesExamples = new Link(this.scene, 0, 145 * CU.S, 'Примеры объектов', () => {
        //     // TODO
        // }, '#bdbdbd', 12, 0.5);

        if(currentDiscount === undefined){
            currentDiscount = p.activatableDiscount;
        }

        let priceWithUsableDiscount = Math.floor(p.price.mithril * (1 - (currentDiscount? currentDiscount : 0) / 100));
        let finalPrice = Math.min( p.price.mithril, priceWithUsableDiscount);

        let buyButton = new BuyButton(this.scene, 0, 245, p.discount ? p.discount.oldPrice.mithril : p.price.mithril,
            finalPrice, clickSound, () => {onAcceptCallback(currentDiscount)});

        this.add([back, portal, buttonLight, textBlock, lengthText, buyButton]);

        if (p.price.mithril <= 0 && p.imageKey === 'P1' && !currentDiscount) {

            let discText = TextUtils.addText(this.scene,  Tr('one.free'),
                2, 169, '#a8a8a8',
                11, 'normal', 400);
            this.add(discText);

        } else if (currentDiscount){
            let discText = TextUtils.addText(this.scene, TrSpace('discount.used'),
                2, 169, '#a8a8a8',
                11, 'normal', 400);

            this.add(discText);
        } else if (p.discount && p.discount.oldPrice.mithril !== p.price.mithril) {
            let discText = TextUtils.addText(this.scene, TrSpace('fromC') + p.discount.fromDate + SpaceTrSpace('to') + p.discount.toDate + Tr('h.d'),
                2, 169, '#a8a8a8',
                11, 'normal', 400);

            this.add(discText);
        }

        let self = this;
        if(discounts){
            self.addDiscountRadioButtons(p, clickSound, onAcceptCallback, discounts, currentDiscount);
        } else {
            PlayerStore.fetchPortalDiscounts(p.portalId).then((discounts2: number[]) => {
                self.addDiscountRadioButtons(p, clickSound, onAcceptCallback, discounts2, currentDiscount);
            });
        }
    }

    //ползунок со скидкой
    private addDiscountRadioButtons(p: PortalDto, clickSound: BaseSound, onAcceptCallback: () => unknown, discounts:number[], currentDiscount?:number){
        let self = this;
        let countByPercent = new Map<number, number>();
        for (let d of discounts) {
            if (countByPercent.has(d)) {
                countByPercent.set(d, countByPercent.get(d)! + 1);
            } else {
                countByPercent.set(d, 1);
            }
        }

        let y0 = 315;
        let dy = 65;
        let keysSorted = Array.from(countByPercent.keys()).sort((a, b) => b - a);
        for(let k of keysSorted) {
            let cnt = countByPercent.get(k)!;
            let text = TextUtils.addText(this.scene, Tr('discount') + ': ' + k
                + '% ' +  (cnt > 1? '(' + cnt + ')' : ''), -220-5, y0 - 30, '#a8a8a8',
                9, 'normal', 400);
            text.setOrigin(0, 0.5)

            let btn = SpriteUtils.addSprite(this.scene, -185-5, y0, (currentDiscount == k?  Keys.UI_DISCOUNT_ENABLED : Keys.UI_DISCOUNT_DISABLED));
            btn.setInteractive().on('pointerup', () => {
                self.list.slice().forEach(child => {
                    if(child != self.background && child != self.xButton && child != self.title && child != self.window){
                        child.destroy();
                    }
                });
                if(currentDiscount == k) {
                    self.init(p, clickSound, onAcceptCallback, discounts, 0);
                    PortalStore.markDiscountChosen(0, p.portalId);
                } else {
                    self.init(p, clickSound, onAcceptCallback, discounts, k);
                    PortalStore.markDiscountChosen(k, p.portalId);
                }
            });

            this.add([text, btn]);
            y0 -= dy;
        }
    }

    protected onClose(): void {

    }

}
